@for (item of transformedItems; track item; let i = $index) {
  @if (item.hidden !== true) {
    <app-filter-button (action)="SetAction($event)" [preLabel]="preLabel" [label]="item.label" [active]="item.active" [id]="item.id" ></app-filter-button>
  }
}

